import { render, staticRenderFns } from "./assigned-client.vue?vue&type=template&id=06d130dd&scoped=true"
import script from "./assigned-client.vue?vue&type=script&lang=js"
export * from "./assigned-client.vue?vue&type=script&lang=js"
import style0 from "./assigned-client.vue?vue&type=style&index=0&id=06d130dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d130dd",
  null
  
)

export default component.exports